import { Banknote, Camera, FileText, FlaskConical, MapPin, RotateCcw, RotateCw, Search, Users, type LucideIcon } from 'lucide-react';

/**
 * Tipos de visita que se pueden PEDIR desde Claims/Scheduling (botón "Request …").
 * Cada uno manda el claim a Scheduling → "Waiting to Schedule" con su sub-estatus.
 */
export const REQUEST_VISIT_TYPES: ReadonlyArray<{ type: string; labelKey: string; icon: LucideIcon }> = [
  { type: 'inspection', labelKey: 'req.inspection', icon: Search },
  { type: 'atr', labelKey: 'req.atr', icon: FileText },
  // ATR con el ajustador del seguro presente: misma cola que el ATR, pero la cita se agenda como
  // reunión con el adjuster porque hay que coordinar con el otro lado (pedido 2026-08-21).
  { type: 'atr_adjuster', labelKey: 'req.atrAdjuster', icon: Users },
  // ATR ON SITE (Manuel 2026-09-30): misma cola que el ATR, tipo de cita propio (duración y buffer en Settings → Scheduling).
  { type: 'atr_on_site', labelKey: 'req.atrOnSite', icon: MapPin },
  // Solo fotos. Tenía que existir aparte: el equipo lo venía pidiendo como ATR y aclarando en la
  // nota, así que la cola de ATR mezclaba dos trabajos distintos y el inspector no sabía qué iba a
  // hacer hasta leer el texto.
  { type: 'photos', labelKey: 'req.photos', icon: Camera },
  { type: 'reinspection', labelKey: 'req.reinspection', icon: RotateCcw },
  { type: 'check_pickup', labelKey: 'req.checkPickup', icon: Banknote },
  { type: 'material_sample', labelKey: 'req.materialSample', icon: FlaskConical },
  { type: 'reschedule', labelKey: 'req.reschedule', icon: RotateCw },
] as const;

/** Tipo de solicitud (botón/dropdown "Request …") → tipo de CITA que se debe agendar.
 *  Cada tipo tiene su duración propia en el backend (atr 30min, check_pickup 15min, etc.). */
export const REQUEST_TYPE_TO_APPT_TYPE: Record<string, string> = {
  inspection: 'inspection',
  atr: 'atr',
  atr_adjuster: 'adjuster_meeting',
  atr_on_site: 'atr_on_site',
  photos: 'photos',
  reinspection: 'adjuster_meeting',
  check_pickup: 'check_pickup',
  material_sample: 'material_sample',
  reschedule: 'inspection',
};

/** Sub-estatus de scheduling → tipo de cita para abrir el Schedule modal con el tipo correcto. */
export const SCHED_STATUS_TO_APPT_TYPE: Record<string, string> = {
  'ATR request': 'atr',
  'Photos': 'photos',
  'Re-inspection requested': 'adjuster_meeting',
  'Check pickup': 'check_pickup',
  'Material sample': 'material_sample',
  'Needs Reschedule': 'inspection',
  'Claim in': 'inspection',
};
